export const INIT_LEARNING_SESSION = 'INIT_LEARNING_SESSION';
export const RESET_LEARNING_SESSION = 'RESET_LEARNING_SESSION';

export const SET_LEARNING_PACKAGE_LOADING = 'SET_LEARNING_PACKAGE_LOADING';
export const SET_LEARNING_PACKAGE_SUCCESS = 'SET_LEARNING_PACKAGE_SUCCESS';
export const HYDRATE_LEARNING_INVITE_PROGRESS = 'HYDRATE_LEARNING_INVITE_PROGRESS';
export const RESTORE_TRAINING_PROGRESS = 'RESTORE_TRAINING_PROGRESS';
export const RESET_LEARNING_INVITE_PROGRESS = 'RESET_LEARNING_INVITE_PROGRESS';
export const SET_LEARNING_RECIPIENT_EMAIL = 'SET_LEARNING_RECIPIENT_EMAIL';
export const SET_LEARNING_PACKAGE_ERROR = 'SET_LEARNING_PACKAGE_ERROR';

export const SET_LEARNING_PHASE = 'SET_LEARNING_PHASE';
export const SET_LEARNING_ATTEMPTS_USED = 'SET_LEARNING_ATTEMPTS_USED';
export const SET_LEARNING_INVITE_LOCKED = 'SET_LEARNING_INVITE_LOCKED';
export const SET_LEARNING_QUIZ_RESULT = 'SET_LEARNING_QUIZ_RESULT';
export const CLEAR_LEARNING_QUIZ_RESULT = 'CLEAR_LEARNING_QUIZ_RESULT';

export const SET_LEARNING_GUIDANCE_INDEX = 'SET_LEARNING_GUIDANCE_INDEX';
export const SET_LEARNING_DOCUMENT_SCROLL = 'SET_LEARNING_DOCUMENT_SCROLL';
export const RESET_LEARNING_GUIDANCE = 'RESET_LEARNING_GUIDANCE';

export const SET_LEARNING_QUESTIONNAIRE_LOADING = 'SET_LEARNING_QUESTIONNAIRE_LOADING';
export const SET_LEARNING_QUESTIONNAIRE_SURVEY = 'SET_LEARNING_QUESTIONNAIRE_SURVEY';
export const SET_LEARNING_QUESTIONNAIRE_ERROR = 'SET_LEARNING_QUESTIONNAIRE_ERROR';
export const SET_LEARNING_QUESTION_INDEX = 'SET_LEARNING_QUESTION_INDEX';
export const SET_LEARNING_QUESTIONNAIRE_SUBMITTED = 'SET_LEARNING_QUESTIONNAIRE_SUBMITTED';
export const RESET_LEARNING_QUESTIONNAIRE = 'RESET_LEARNING_QUESTIONNAIRE';

export const SET_LEARNING_BRAND_SUCCESS = 'SET_LEARNING_BRAND_SUCCESS';
export const CLEAR_LEARNING_BRAND = 'CLEAR_LEARNING_BRAND';
